export default __webpack_public_path__ + "static/media/Reunification.fd543868.jpg";